module.exports = __webpack_public_path__ + "img/couples-040.49baf67d.jpg";